var BTaxAccountStatus;
(function (BTaxAccountStatus) {
    BTaxAccountStatus["ACTIVE"] = "active";
    BTaxAccountStatus["PENDING"] = "pending";
    BTaxAccountStatus["CLOSED"] = "closed";
    BTaxAccountStatus["CATEGORY_DELETED"] = "category deleted";
    BTaxAccountStatus["TBD"] = "tbd";
})(BTaxAccountStatus || (BTaxAccountStatus = {}));
const BTAX_ACCOUNT_STATUS_NAMES = {
    [BTaxAccountStatus.ACTIVE]: 'Active',
    [BTaxAccountStatus.PENDING]: 'Pending',
    [BTaxAccountStatus.CLOSED]: 'Closed',
    [BTaxAccountStatus.CATEGORY_DELETED]: 'Category Deleted',
    [BTaxAccountStatus.TBD]: 'To Be Determined',
};
const BTAX_ACCOUNT_STATUS_ICONS = {
    [BTaxAccountStatus.ACTIVE]: 'check',
    [BTaxAccountStatus.PENDING]: 'pending_actions',
    [BTaxAccountStatus.CLOSED]: 'cancel',
    [BTaxAccountStatus.CATEGORY_DELETED]: 'highlight_off',
    [BTaxAccountStatus.TBD]: 'pending_actions',
};

// Status
const BTAX_STATUS_ID_TO_LABEL_MAP = {
    exempt: 'Exempt',
    unpaid: 'Unpaid',
    paid: 'Paid',
};
function getStatusForBTaxBill(bill) {
    if (bill.exemptions?.length)
        return 'exempt';
    if (!bill.paid)
        return 'unpaid';
    else
        return 'paid';
}
function getStatusLabelForBTaxBill(bill) {
    return BTAX_STATUS_ID_TO_LABEL_MAP[getStatusForBTaxBill(bill)];
}

/**
 * Generated bundle index. Do not edit.
 */

export { BTAX_ACCOUNT_STATUS_ICONS, BTAX_ACCOUNT_STATUS_NAMES, BTAX_STATUS_ID_TO_LABEL_MAP, BTaxAccountStatus, getStatusForBTaxBill, getStatusLabelForBTaxBill };
